import script from "./SpinnerLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerLoader.vue?vue&type=script&setup=true&lang=ts"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=9c3a54d6&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3a54d6"]])

export default __exports__